import React from "react";
import { Link } from "react-router-dom";
import {
  FiPhone,
  FiMail,
  FiMapPin,
  FiArrowRight,
  FiFacebook,
  FiInstagram,
} from "react-icons/fi";
import "./Footer.css";
import logo from "../images/logo.png";

const FB = "https://www.facebook.com/share/1aF6XPZiM4/";
const INSTA =
  "https://www.instagram.com/shaheeninternationalsports16?igsh=MWdmNG5lb2RieDFoMw==";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__main">
        <div className="container footer__grid">
          {/* Brand */}
          <div className="footer__brand">
            <div className="footer__logo">
              <img
                src={logo}
                alt="Shaheen Sports"
                className="footer__logo-img"
              />
              <span>Shaheen Sports</span>
            </div>
            <p className="footer__desc">
              Premium manufacturer and exporter of Judo Gis, Jiujitsu Gis, MMA
              gear and martial arts accessories. Headquartered in Gujranwala,
              Pakistan.
            </p>
            <div className="footer__est">
              <span>Est. 2020</span>
              <span>Gujranwala, Pakistan</span>
            </div>

            {/* Social Buttons */}
            <div className="footer__socials">
              <a
                href={FB}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social footer__social--fb"
                aria-label="Facebook"
              >
                <FiFacebook size={17} />
                <span>Facebook</span>
              </a>
              <a
                href={INSTA}
                target="_blank"
                rel="noopener noreferrer"
                className="footer__social footer__social--ig"
                aria-label="Instagram"
              >
                <FiInstagram size={17} />
                <span>Instagram</span>
              </a>
            </div>
          </div>

          {/* Uniforms */}
          <div className="footer__col">
            <h4 className="footer__heading">Uniforms</h4>
            <ul>
              {[
                { l: "All Products", p: "/all-products" },
                { l: "Judo Gi", p: "/uniforms/judo-gi" },
                { l: "Jiujitsu Gi", p: "/uniforms/jiujitsu-gi" },
              ].map((i) => (
                <li key={i.l}>
                  <Link to={i.p} className="footer__link">
                    <FiArrowRight size={11} />
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
            <h4 className="footer__heading" style={{ marginTop: "1.5rem" }}>
              Belts
            </h4>
            <ul>
              {[{ l: "All Belts", p: "/products/belts" }].map((i) => (
                <li key={i.l}>
                  <Link to={i.p} className="footer__link">
                    <FiArrowRight size={11} />
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div className="footer__col">
            <h4 className="footer__heading">Other Products</h4>
            <ul>
              {[
                { l: "MMA Shorts", p: "/products/mma-shorts" },
                { l: "Rash Guards", p: "/products/rash-guards" },
                { l: "Spats", p: "/products/spats" },
                { l: "Sports Bra", p: "/products/sports-bra" },
                { l: "Sports Hoodies", p: "/products/sports-hoodies" },
                { l: "Separate Patches", p: "/products/patches" },
              ].map((i) => (
                <li key={i.l}>
                  <Link to={i.p} className="footer__link">
                    <FiArrowRight size={11} />
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="footer__col">
            <h4 className="footer__heading">Contact Us</h4>
            <div className="footer__contact-list">
              <div className="footer__contact-item">
                <FiPhone size={14} />
                <div>
                  <a href="tel:+923420757213">+92-342-075 7213</a>
                </div>
              </div>
              <div className="footer__contact-item">
                <FiMail size={14} />
                <div>
                  <a href="mailto:ShaheenInternationalSports1@gmail.com">
                    ShaheenInternationalSports1@gmail.com
                  </a>
                </div>
              </div>

              {/* Social links in contact col */}
              <div className="footer__contact-item">
                <FiFacebook
                  size={14}
                  style={{ color: "#1877F2", flexShrink: 0 }}
                />
                <a
                  href={FB}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                >
                  Facebook Page
                </a>
              </div>
              <div className="footer__contact-item">
                <FiInstagram
                  size={14}
                  style={{ color: "#E1306C", flexShrink: 0 }}
                />
                <a
                  href={INSTA}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "rgba(255,255,255,0.55)" }}
                >
                  Instagram Page
                </a>
              </div>
            </div>

            <Link
              to="/contact"
              className="btn-primary"
              style={{
                marginTop: "1.5rem",
                fontSize: "0.8rem",
                padding: "0.7rem 1.4rem",
              }}
            >
              Get a Quote <FiArrowRight size={14} />
            </Link>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>
            © {new Date().getFullYear()} Shaheen Sports. All rights reserved.
          </p>
          <div className="footer__bottom-socials">
            <a
              href={FB}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__bottom-social"
              aria-label="Facebook"
            >
              <FiFacebook size={16} />
            </a>
            <a
              href={INSTA}
              target="_blank"
              rel="noopener noreferrer"
              className="footer__bottom-social"
              aria-label="Instagram"
            >
              <FiInstagram size={16} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
